import {Directive, Input, Output, ElementRef, HostListener, EventEmitter} from '@angular/core';

@Directive({
  selector: '[appCounter]'
})

export class CounterDirective {

  @Input('number') number : number = 10;
  @Input('dly') delay : number = 10;
  @Input('step') step : number = 1;
  @Output('countInc') countInc = new EventEmitter<any>();

  constructor(private eleRef : ElementRef) {
    this.counter = 0;
  }

  @HostListener("window:scroll", ["$event"])
  onWindowScroll(event){
    if(this.eleRef.nativeElement.parentElement.getBoundingClientRect().top - window.innerHeight > 0
      || this.eleRef.nativeElement.parentElement.getBoundingClientRect().top + this.eleRef.nativeElement.offsetHeight < 0 ) return;

    this.startCounter();

  }

  public timer;
  public counter = 0;

  public CounterInc(){
    if(this.counter < this.number) {
      this.counter += this.step;
      this.countInc.emit(this.counter);
      this.timer = window.setTimeout(this.CounterInc.bind(this), this.delay);
    }else{
      this.stopCounter();
    }
    // console.log(this.counter);
  }

  public stopCounter(){
    if(this.timer) clearTimeout(this.timer);
  }

  public startCounter(){
    if(this.timer) clearTimeout(this.timer);
    this.timer = window.setTimeout(this.CounterInc.bind(this), this.delay);
  }

  ngOnDestroy(){
    if(this.timer) clearTimeout(this.timer);
  }

}
